import $ from 'jquery';
var $myDiv = $('.relatedContentBlock .box-bottom');
if ($myDiv.length) {
    $($myDiv).each(function (index, element) {
        if ($(element).find('.link-download').text().length > 0) {
            $(element).addClass("has-content");
        }
    });
}
